// Layer 2 iframe handshake: ask the dashboard "is the current user signed in
// here?" without a top-level navigation. The dashboard responds with either a
// short-lived bind token (if a session exists) or `no_session`. Times out at
// 1.5s — Safari/Firefox typically block third-party storage, so we fall
// through silently and the user lands on the login wall like normal.
export function tryIframeHandshake(args: {
  dashboardOrigin: string;
  widgetToken: string;
}): Promise<{ bindToken: string } | null> {
  return new Promise((resolve) => {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('aria-hidden', 'true');
    iframe.style.cssText = 'display:none;width:0;height:0;border:0;';
    const params = new URLSearchParams({
      widget_token: args.widgetToken,
      origin: window.location.origin,
    });
    iframe.src = `${args.dashboardOrigin}/auth/widget-handshake?${params.toString()}`;

    const cleanup = () => {
      window.removeEventListener('message', onMessage);
      iframe.remove();
      clearTimeout(timer);
    };

    const onMessage = (e: MessageEvent) => {
      if (e.origin !== args.dashboardOrigin) return;
      if (e.source !== iframe.contentWindow) return;
      const data = e.data as { kind?: string; token?: string } | null;
      cleanup();
      if (data?.kind === 'bind_token' && typeof data.token === 'string') {
        resolve({ bindToken: data.token });
      } else {
        resolve(null);
      }
    };

    const timer = setTimeout(() => {
      cleanup();
      resolve(null);
    }, 1500);

    window.addEventListener('message', onMessage);
    document.body.appendChild(iframe);
  });
}
